import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const NAV_ITEMS = [
  { label: '首页', to: '/' },
  { label: '议题追踪', to: '/topics' },
  { label: '维权指南', to: '/guide' },
  { label: '关于我们', to: '/about' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  const isActive = (to: string) =>
    to === '/' ? pathname === '/' : pathname === to || pathname.startsWith(`${to}/`);

  const today = new Date();
  const dateText = `${today.getFullYear()}年${today.getMonth() + 1}月${today.getDate()}日`;

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="hidden w-full border-b border-foreground-900 bg-foreground-950 md:block">
        <div className="mx-auto flex max-w-[1200px] items-center justify-between px-6 py-2">
          <p className="font-label text-xs text-background-200">
            聚焦社会议题 · 还原事件脉络 · 提供维权参考
          </p>
          <div className="flex items-center gap-4 font-label text-xs text-background-200">
            <span>{dateText}</span>
            <Link to="/about#contact" className="transition-colors hover:text-accent-400">
              提供线索
            </Link>
          </div>
        </div>
      </div>

      <div className="w-full border-b border-background-300 bg-background-50/95 backdrop-blur">
        <div className="mx-auto flex max-w-[1200px] items-center justify-between px-4 py-3 md:px-6 md:py-4">
          <Link to="/" className="flex items-center gap-2.5" aria-label="锐察社首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
              <i className="ri-radar-line text-xl" aria-hidden="true"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-xl font-bold tracking-tight text-foreground-950">
                锐察社
              </span>
              <span className="mt-0.5 font-label text-[10px] uppercase tracking-[0.24em] text-foreground-500">
                Ruicha Observer
              </span>
            </span>
          </Link>

          <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`relative rounded-md px-4 py-2 font-label text-sm transition-colors ${
                  isActive(item.to)
                    ? 'text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                }`}
              >
                {item.label}
                {isActive(item.to) && (
                  <span className="absolute inset-x-4 -bottom-0.5 h-0.5 rounded-full bg-primary-600"></span>
                )}
              </Link>
            ))}
            <Link
              to="/topics"
              className="ml-2 inline-flex items-center gap-1 rounded-md bg-primary-600 px-4 py-2 font-label text-sm text-background-50 transition-colors hover:bg-primary-700"
            >
              <i className="ri-search-line" aria-hidden="true"></i>
              查看议题
            </Link>
          </nav>

          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden"
            aria-label={open ? '关闭菜单' : '打开菜单'}
            aria-expanded={open}
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true"></i>
          </button>
        </div>

        {open && (
          <nav className="border-t border-background-200 bg-background-50 md:hidden" aria-label="移动端导航">
            <ul className="mx-auto max-w-[1200px] px-4 py-2">
              {NAV_ITEMS.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    onClick={() => setOpen(false)}
                    className={`flex items-center justify-between rounded-md px-3 py-3 font-label text-sm ${
                      isActive(item.to)
                        ? 'bg-primary-50 text-primary-700'
                        : 'text-foreground-700 hover:bg-background-100'
                    }`}
                  >
                    {item.label}
                    <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        )}
      </div>
    </header>
  );
}